<template>
  <v-card>
    <v-card-text>
      <form data-vv-scope="tarfFactForm">
        <v-layout row wrap>
          <v-flex row xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-flex xs6 v-if="!newFact">
            <v-subheader class="queryLabel">{{labels.seqNo}}</v-subheader>
            <div class="title">{{tarfFactForm.seqNo}}</div>
          </v-flex>
          <v-flex xs6 v-else>
            <v-text-field data-vv-scope="tarfFactForm" v-model="tarfFactForm.seqNo" :label="labels.seqNo" :error-messages="errors.collect('tarfFactForm.seqNo')" data-vv-name="seqNo" :data-vv-as="labels.seqNo" v-validate="'required|numeric|max:10'"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field data-vv-scope="tarfFactForm" v-model="tarfFactForm.description" :label="labels.description" :error-messages="errors.collect('tarfFactForm.description')" data-vv-name="description" :data-vv-as="labels.description" v-validate="'required|entry|max:40'"></v-text-field>
          </v-flex>
          <v-flex xs6 v-if="!newFact">
            <cal-picker data-vv-scope = "tarfFactForm" :label="labels.effDate" v-model="tarfFactForm.effDate" :error-messages="errors.collect('tarfFactForm.effDate')" data-vv-name="effDate" :data-vv-as="labels.effDate" v-validate="'required'" readonly></cal-picker>
          </v-flex>
          <v-flex xs6 v-else>
            <cal-picker data-vv-scope = "tarfFactForm" :label="labels.effDate" v-model="tarfFactForm.effDate" :error-messages="errors.collect('tarfFactForm.effDate')" data-vv-name="effDate" :data-vv-as="labels.effDate" v-validate="'required'"></cal-picker>
          </v-flex>
          <v-flex xs6>
            <cal-picker data-vv-scope = "tarfFactForm" :label="labels.expDate" v-model="tarfFactForm.expDate" :error-messages="errors.collect('tarfFactForm.expDate')" data-vv-name="expDate" :data-vv-as="labels.expDate" :min="tarfFactForm.effDate"></cal-picker>
          </v-flex>
          <v-flex xs6>
            <v-layout column wrap>
              <v-flex xs6>
                <v-autocomplete data-vv-scope="tarfFactForm" :items="factStringList" v-model="tarfFactForm.factorByFact1" :label="labels.factorByFact1" item-text="label" item-value="value" :error-messages="errors.collect('tarfFactForm.factorByFact1')" data-vv-name="factorByFact1" :data-vv-as="labels.factorByFact1" clearable></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete data-vv-scope="tarfFactForm" :items="factStringList" v-model="tarfFactForm.factorByFact2" :label="labels.factorByFact2" item-text="label" item-value="value" :error-messages="errors.collect('tarfFactForm.factorByFact2')" data-vv-name="factorByFact2" :data-vv-as="labels.factorByFact2" clearable></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete data-vv-scope="tarfFactForm" :items="factStringList" v-model="tarfFactForm.factorByFact3" :label="labels.factorByFact3" item-text="label" item-value="value" :error-messages="errors.collect('tarfFactForm.factorByFact3')" data-vv-name="factorByFact3" :data-vv-as="labels.factorByFact3" clearable></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs6>
            <v-layout column wrap>
              <v-flex xs6>
                <v-autocomplete data-vv-scope="tarfFactForm" :items="factNumList" v-model="tarfFactForm.factorByFact4" :label="labels.factorByFact4" item-text="label" item-value="value" :error-messages="errors.collect('tarfFactForm.factorByFact4')" data-vv-name="factorByFact4" :data-vv-as="labels.factorByFact4" clearable></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete data-vv-scope="tarfFactForm" :items="factNumList" v-model="tarfFactForm.factorByFact5" :label="labels.factorByFact5" item-text="label" item-value="value" :error-messages="errors.collect('tarfFactForm.factorByFact5')" data-vv-name="factorByFact5" :data-vv-as="labels.factorByFact5" clearable></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete data-vv-scope="tarfFactForm" :items="factNumList" v-model="tarfFactForm.factorByFact6" :label="labels.factorByFact6" item-text="label" item-value="value" :error-messages="errors.collect('tarfFactForm.factorByFact6')" data-vv-name="factorByFact6" :data-vv-as="labels.factorByFact6" clearable></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSaveTarfFactForm">
        {{newFact ? 'Save Factor' : 'Update Factor'}}
        <v-icon right>{{newFact ? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import FieldMixin from '@/mixins/field'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
export default {
  data() {
    return {
      tarfFactForm: {
        busCls: null,
        tarf: null,
        benefit: null,
        seqNo: null,
        effDate: null,
        expDate: null,
        description: null,
        factorByFact1: null,
        factorByFact2: null,
        factorByFact3: null,
        factorByFact4: null,
        factorByFact5: null,
        factorByFact6: null
      },
      labels: {
        seqNo: 'Sequence*',
        effDate: 'Effective Date*',
        expDate: 'Expired Date',
        description: 'Factor Description*',
        factorByFact1: 'Factor 1',
        factorByFact2: 'Factor 2',
        factorByFact3: 'Factor 3',
        factorByFact4: 'Factor 4',
        factorByFact5: 'Factor 5',
        factorByFact6: 'Factor 6'
      },
      loading: false,
      submitting: false,
      newFact: null,
      factNumList: [],
      factStringList: []
    }
  },
  watch: {
    'ids.seqNo': function(value) {
      Promise.all([this.doFactorInit()])
      if (value !== 'new') {
        this.resetValidator()
        this.resetMessages()
        this.newFact = false
        this.fetchForm(value)
      } else {
        this.newFact = true
        this.doClearForm()
      }
    }
  },
  computed: {
    tarfBenefitMenu() {
      return this.$store.state.parameters.tariff.benefit.menu
    }
  },
  methods: {
    async fetchForm(seqNo) {
      const apiURI = this.tarfBenefitMenu.tarfFactorGet
      if (apiURI) {
        try {
          const expand = {
            busCls: this.ids.busCls,
            tarf: this.ids.tarf,
            benefit: this.ids.benefit,
            seqNo: seqNo,
            effDate: this.ids.factEffDate
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.tarfFactForm.busCls = this.ids.busCls
            this.tarfFactForm.tarf = this.ids.tarf
            this.tarfFactForm.benefit = this.ids.benefit
            this.tarfFactForm.seqNo = data.tarfFact.seqNo
            this.tarfFactForm.description = data.tarfFact.description
            this.tarfFactForm.effDate = data.tarfFact.effDate
            this.tarfFactForm.expDate = data.tarfFact.expDate
            this.tarfFactForm.factorByFact1 = this.isNullFactor(data.tarfFact.factorByFact1)
            this.tarfFactForm.factorByFact2 = this.isNullFactor(data.tarfFact.factorByFact2)
            this.tarfFactForm.factorByFact3 = this.isNullFactor(data.tarfFact.factorByFact3)
            this.tarfFactForm.factorByFact4 = this.isNullFactor(data.tarfFact.factorByFact4)
            this.tarfFactForm.factorByFact5 = this.isNullFactor(data.tarfFact.factorByFact5)
            this.tarfFactForm.factorByFact6 = this.isNullFactor(data.tarfFact.factorByFact6)

            // extract Menu
            this.menu = extractMenu(result.data._links)

            this.ids.factorByFact1 = this.tarfFactForm.factorByFact1
            this.ids.factorByFact2 = this.tarfFactForm.factorByFact2
            this.ids.factorByFact3 = this.tarfFactForm.factorByFact3
            this.ids.factorByFact4 = this.tarfFactForm.factorByFact4
            this.ids.factorByFact5 = this.tarfFactForm.factorByFact5
            this.ids.factorByFact6 = this.tarfFactForm.factorByFact6
            this.ids.rateEffDate = null
          }
        } catch (err) {
          console.log(err)
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url - Tariff Factor Form')
      }
    },
    doSaveTarfFactForm() {
      this.resetMessages()
      this.$validator.validateAll('tarfFactForm').then(result => {
        if (result) {
          if (this.newFact) {
            this.doCreateTarfFactForm()
          } else {
            this.doUpdateTarfFactForm()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doClearForm() {
      this.resetValidator()
      this.resetMessages()
      this.tarfFactForm.busCls = this.ids.busCls
      this.tarfFactForm.tarf = this.ids.tarf
      this.tarfFactForm.benefit = this.ids.benefit
      this.tarfFactForm.seqNo = null
      this.tarfFactForm.effDate = null
      this.tarfFactForm.expDate = null
      this.tarfFactForm.description = null
      this.tarfFactForm.factorByFact1 = null
      this.tarfFactForm.factorByFact2 = null
      this.tarfFactForm.factorByFact3 = null
      this.tarfFactForm.factorByFact4 = null
      this.tarfFactForm.factorByFact5 = null
      this.tarfFactForm.factorByFact6 = null
    },
    async doCreateTarfFactForm() {
      const apiURI = this.tarfBenefitMenu.tarfFactorCreate
      if (apiURI) {
        try {
          const formatForm = {
            busCls: this.ids.busCls,
            tarf: this.ids.tarf,
            benefit: this.ids.benefit,
            effDate: this.tarfFactForm.effDate,
            seqNo: this.tarfFactForm.seqNo,
            expDate: this.tarfFactForm.expDate,
            description: this.tarfFactForm.description,
            factorByFact1: this.tarfFactForm.factorByFact1,
            factorByFact2: this.tarfFactForm.factorByFact2,
            factorByFact3: this.tarfFactForm.factorByFact3,
            factorByFact4: this.tarfFactForm.factorByFact4,
            factorByFact5: this.tarfFactForm.factorByFact5,
            factorByFact6: this.tarfFactForm.factorByFact6
          }
          const result = await this.$http.post(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doClearForm()
            this.$emit('resetTab', 3)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url')
      }
    },
    async doUpdateTarfFactForm() {
      const apiURI = this.menu.tarfFactorUpdate
      if (apiURI) {
        try {
          const formatForm = {
            busCls: this.ids.busCls,
            tarf: this.ids.tarf,
            benefit: this.ids.benefit,
            effDate: this.tarfFactForm.effDate,
            seqNo: this.tarfFactForm.seqNo,
            expDate: this.tarfFactForm.expDate,
            description: this.tarfFactForm.description,
            factorByFact1: this.tarfFactForm.factorByFact1,
            factorByFact2: this.tarfFactForm.factorByFact2,
            factorByFact3: this.tarfFactForm.factorByFact3,
            factorByFact4: this.tarfFactForm.factorByFact4,
            factorByFact5: this.tarfFactForm.factorByFact5,
            factorByFact6: this.tarfFactForm.factorByFact6
          }
          const result = await this.$http.put(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.fetchForm(this.ids.seqNo)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url')
      }
    },
    isNullFactor(value) {
      if (typeof value === 'undefined') {
        return null
      } else {
        return value
      }
    },
    async doFactorInit() {
      const apiURI = this.tarfBenefitMenu.factorList
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            if (this.factNumList > 0) {
              this.factNumList = []
            }
            if (this.factStringList > 0) {
              this.factStringList = []
            }
            this.factStringList = data.factStringList
            this.factNumList = data.factNumList
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url - factor List')
      }
    }
  },
  props: {
    ids: {
      type: Object,
      default () {
        return {
          busCls: null,
          tarf: null,
          benefit: null,
          factEffDate: null
        }
      }
    }
  },
  mixins: [
    FieldMixin,
    MessageMixin
  ]
}
</script>

<style>

</style>
